export const getDobString = (age) => {
  let dobString;
  if (age === '' || Number.isNaN(age)) {
    dobString = '';
  } else if (age < 1) {
    dobString = `(0)`;
  } else {
    dobString = `(${age})`;
  }
  return dobString;
};

export const getFullName = (patientDetails) => {
  return [
    patientDetails?.firstName?.value || '',
    patientDetails?.lastName?.value || '',
  ]
    .join(' ')
    .trim();
};

export const hasExistingDevices = (rawPatientDetails) => {
  const personas = rawPatientDetails?.data?.personas ?? null;

  if (
    !personas ||
    personas.includes('Pending') ||
    personas.includes('Candidate')
  ) {
    return false;
  }
  return true;
};

export const createRedirectToContactUs = (country, lang) => {
  return () => {
    window.location.href = `https://www.cochlear.com/${country}/${lang}/connect/contact-us/`;
  };
};

export const createAlmRequestBody = (
  id,
  type,
  personalDetails,
  professionalId,
  providerId,
  country,
  lang,
  relatedDependent = null,
) => {
  const isoDate = new Date().toISOString();
  const resend =
    personalDetails?.accountDetails?.rawStatus === 'invited';

  const requestBody = {
    cochlearId: id,
    professionalId,
    providerId,
    firstName: personalDetails?.firstName?.value,
    lastName: personalDetails?.lastName?.value,
    email: personalDetails?.email?.value,
    countryCode: country?.toUpperCase(),
    languageCode: lang,
    accountFor: type,
    privacyAcceptDate: isoDate,
    sendActivationEmail: true,
    resend,
    relatedDependent,
    channel: 'DPX',
    performer: {
      cochlearId: professionalId,
      type: 'PROFESSIONAL',
    },
  };

  // Only include dateOfBirth if it has a value (not null, undefined, or empty string)
  // For carers, DOB is optional and can be omitted
  const dob = personalDetails?.dateOfBirth?.value;
  if (dob && dob !== '') {
    requestBody.dateOfBirth = dob;
  }

  return requestBody;
};
